import React, { useState } from 'react';
import { IoSparkles } from 'react-icons/io5';
import { Dialog } from './Dialog';
import AiAssistChat from './AiAssistChat';
import { moduleEnabledOrOpenIntercom } from '../javascript/helpers/validate_module';

interface AiAssistProps {
  formFillID: number;
  moduleContracted: boolean;
}

export const AiAssistComponent: React.FC<AiAssistProps> = ({ formFillID, moduleContracted }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [load, setLoad] = useState<boolean>(false);

  const handleOpenModal = () => {
    const successCallback = () => {
      setModalOpen(true);
      setLoad(true);
    };

    moduleEnabledOrOpenIntercom(
      moduleContracted,
      successCallback,
      'Olá! Quero usar a Manu IA para ajudar com os relatórios. ' +
        'Hoje perco tempo reescrevendo os textos, e vi que ela melhora e resume o que escrevi, para apresentar ao meu cliente.\n' +
        'Pode me explicar como contratar?'
    );
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    if (refresh) {
      legacyRefreshViewAfterUpdateFormFill();
    }
  };

  const legacyRefreshViewAfterUpdateFormFill = () => {
    const url = `/form_fills/${formFillID}.js`;
    $.ajax({
      url: url,
      success: function (_data) {},
      error: function (_error) {
        alert('Ocorreu um erro e tela será recarregada.');
        window.location.reload();
      },
    });
  };

  return (
    <>
      <button
        className="mdl-button mdl-js-button mdl-js-ripple-effect button-primary action-btn white-default light-border"
        onClick={handleOpenModal}
      >
        <IoSparkles fontSize={'1.25em'} />
        Consultar a IA
      </button>

      <Dialog isOpen={modalOpen} onClose={handleCloseModal} isBeta={true} title="IA Produttivo">
        <AiAssistChat formFillID={formFillID} refresh={setRefresh} loadMessages={load} />
      </Dialog>
    </>
  );
};
